<template>
  <AppPage
    title="Support"
    iconName="fa-solid fa-life-ring"
    :message="message"
    :workingDialog="busy"
  >
    <v-container class="fill-height align-center justify-center">
      <v-card class="pa-5 ma-5">
        <template v-if="!submitted">
          <v-card-title>
            <v-icon color="primary" left class="mr-2">fa-solid fa-life-ring</v-icon>
            Support request
          </v-card-title>
          <v-card-text>
            <v-form ref="supportForm">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="Subject"
                    v-model="supportRequest.subject"
                    :rules="[rules.required]"
                    maxlength="100"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Message"
                    v-model="supportRequest.message"
                    :rules="[rules.required]"
                    maxlength="1000"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn txt color="primary" @click.stop="submitRequest">Send</v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-title>
            <v-icon color="primary" left class="mr-2">fa-solid fa-life-ring</v-icon> Support request submitted
          </v-card-title>
          <v-card-text>
            We have received your support request and will contact you soon.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn txt color="primary" @click.stop="createAnother">Create Another Request</v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-container>
  </AppPage>
</template>

<script>
import { ExceptionMessage, Rules } from '@itus/ui.common'
import { mapState } from 'vuex'
import AppPage from '@/components/AppPage'

export default {
  name: 'Support',
  data() {
    return {
      submitted: true,
      rules: Rules,
      message : { type: 'error', show: false, text: '' },
      busy: { show: false },
      supportRequest: {
        subject: '',
        message: ''
      }
    }
  },
  components: {
    AppPage
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    showException(err, defaultMsg) {
      this.message = ExceptionMessage.generateMessage(err, defaultMsg)
    },
    async submitRequest() {
      if(!this.$refs.supportForm.validate())
        return

      try {
        this.busy.show = true
        let params = {
          email: this.user.email,
          subject: this.supportRequest.subject,
          message: this.supportRequest.message,
          firstName: this.user.firstName,
          lastName: this.user.lastName
        }
        await this.$store.dispatch('sendSupportRequest', params)
        this.submitted = true        
      } catch(err) {
        this.showException(err, 'Error submitting support request.')
      } finally {
        this.busy.show = false
      }
    },
    createAnother() {
      this.submitted = false
      this.resetRequest()
    },
    resetRequest() {
      if(this.$refs.supportForm)
        this.$refs.supportForm.reset()

      this.supportRequest.subject = 'Product Support Request'
      this.supportRequest.message = ''
    }
  },
  mounted() {
    this.submitted = false
    this.resetRequest()
  }
}
</script>
